import { includes } from 'lodash';
import { IOrganization } from '../models';

export const hasFeature = (organization: IOrganization, feature: string) =>
  organization && includes(organization.features, feature);
